export default __webpack_public_path__ + "static/sm-logo-745d4efabf741ae4aefa699b3893f1d8.png";